import inputDisabled from '../../../../common/algorithms/input-disabled';

const light = (params) => inputDisabled(params);

export default light;
